import(/* webpackMode: "eager" */ "/codebuild/output/src3122444883/src/apps/webapp/src/app/global-error.tsx");
